const he = {
  'language.name': 'עברית', // its own name, in its own script; the language menu shows it as it is
  'language.dir': 'rtl',
  'language.label': 'שפה',
  'language.current': 'שפה: {name}',
  'app.title': 'המשחק',
  'wordmark.lead': 'ה',
  'wordmark.accent': 'משחק',
  'home.code': 'קוד משחק',
  'home.name': 'מי אני',
  'home.join': 'להצטרף למשחק',
  'home.host': 'לארח משחק',
  'error.gameNotFound': 'המשחק לא נמצא',
  'error.nameTaken': 'השם תפוס',
  'error.blocked': 'יותר מדי קוד שגוי, לא נעים.',
  'error.general': 'משהו השתבש. אפשר לנסות שוב.',
  'error.duplicateCard': 'הקלף הזה כבר קיים',

  'common.yes': 'כן',
  'common.no': 'לא',
  'common.done': 'סיום',
  'common.back': 'חזרה',
  'common.save': 'שמירה',
  'common.username': 'שם משתמש',
  'common.counter': '{n}/{max}',

  'signIn.lead': 'מתחברים כדי לארח משחק\nולבנות חבילות משלכם',
  'signIn.notInvited': 'האימייל הזה עוד לא ברשימת המארחים.',
  'signIn.google': 'התחברות עם Google',
  'signIn.joinWithCode': 'להצטרף למשחק עם קוד',

  'home.nameHint': 'השם הזה מוצג רק במשחק הזה.',
  'home.codePlaceholder': 'XXXX',
  'home.myDecks': 'החבילות שלי',
  'home.accountMenu': 'תפריט החשבון',
  'home.whatNow': 'מה עושים',
  'home.joinWithCode': 'להצטרף עם קוד',
  'home.decksForGame': 'החבילות למשחק',
  'home.questionCards': 'קלפי שאלה',
  'home.answerCards': 'קלפי תשובה',
  'home.noDeck': 'לא נבחרה חבילה',
  'home.pick': 'בחירה',
  'home.change': 'שינוי',
  'home.tileSeparator': ', ',
  'home.tileMore': ' ועוד {count}',
  'home.tileCount': { one: 'חבילה אחת', other: '{count} חבילות' },
  'home.goneBoth': 'החבילות שבחרת למשחק הקודם כבר לא זמינות. צריך לבחור לפחות חבילת שאלות אחת וחבילת תשובות אחת.',
  'home.goneQuestion': 'החבילות שבחרת למשחק הקודם כבר לא זמינות. צריך לבחור לפחות חבילת שאלות אחת.',
  'home.goneAnswer': 'החבילות שבחרת למשחק הקודם כבר לא זמינות. צריך לבחור לפחות חבילת תשובות אחת.',
  'home.tooFew': 'אין מספיק קלפי תשובה: יש {count}, וצריך לפחות {min}. אפשר להוסיף חבילות.',
  'home.create': 'ליצור משחק',
  'home.creating': 'ליצור משחק — בטעינה',
  'home.signedInAs': 'מחוברים בתור',
  'home.myAccount': 'החשבון שלי',
  'home.signOut': 'התנתקות',

  'picker.questionTab': 'קלפי שאלה · {count}',
  'picker.answerTab': 'קלפי תשובה · {count}',
  'picker.cardType': 'סוג הקלפים',
  'picker.createDeck': 'ליצירת חבילה',

  'decks.starter': 'בסיס',
  'decks.mine': 'שלי',
  'decks.sharedWithMe': 'שותפו איתי',
  'decks.noneYet': 'עוד אין לך חבילות.',
  'decks.sharedEmpty': 'כשמישהו ישתף איתך חבילה, היא תופיע כאן.',
  'decks.deckType': 'סוג החבילה',
  'decks.newQuestion': 'חבילת שאלות חדשה',
  'decks.newAnswer': 'חבילת תשובות חדשה',
  'decks.ownShared': '{cards} · משותפת עם {count}',
  'decks.sharedRow': 'של {owner} · {cards}',
  'decks.locked': 'נעולה',

  'deck.cards': { one: 'קלף אחד', other: '{count} קלפים' },
  'deck.defaultName': 'חבילה חדשה',
  'deck.answers': { one: 'תשובה אחת', other: '{count} תשובות' },
  'deck.answersThree': '3 תשובות · כל שחקן מקבל עוד 2 קלפים',
  'deck.viewHint': 'אפשר לשחק עם החבילה הזו. רק הבעלים יכולים לשנות אותה.',
  'deck.editHint': 'אפשר להוסיף, לשנות ולמחוק קלפים. רק הבעלים יכולים למחוק את החבילה או לשתף אותה.',
  'deck.full': 'החבילה מלאה: {count} קלפים. כדי להוסיף קלף, מוחקים קלף אחר.',
  'deck.add': 'הוספה',
  'deck.editCard': 'עריכת קלף',
  'deck.newQuestionCard': 'קלף שאלה חדש',
  'deck.newAnswerCard': 'קלף תשובה חדש',
  'deck.cardPlaceholder': 'מה כתוב על הקלף?',
  'deck.blank': 'מקום ריק',
  'deck.maxBlanks': 'בקלף יש כבר 2 מקומות ריקים, זה המקסימום. צריך 2 תשובות.',
  'deck.howManyAnswers': 'כמה תשובות צריך',
  'deck.answersHint': 'בוחרים רק בקלף בלי מקומות ריקים. בקלף עם מקומות ריקים צריך תשובה לכל מקום, והבחירה הזאת לא מוצגת. ב־3 תשובות כל שחקן מקבל עוד 2 קלפים מהחבילה.',
  'deck.share': 'שיתוף',
  'deck.name': 'שם החבילה',
  'deck.ownedBy': 'של',
  'deck.empty': 'עוד אין קלפים בחבילה. כותבים קלף למעלה ולוחצים ״הוספה״.',
  'deck.editThisCard': 'עריכת הקלף',
  'deck.deleteCard': 'מחיקת הקלף',
  'deck.cancelEdit': 'ביטול העריכה',
  'deck.delete': 'מחיקת החבילה',
  'deck.deleteConfirm': 'למחוק את החבילה?',

  'account.hint': 'חברים משתפים איתך חבילות לפי השם הזה. מי שמקבל ממך חבילה רואה אותו.',
  'account.taken': 'השם הזה כבר תפוס. נסו שם אחר.',
  'account.delete': 'מחיקת החשבון',
  'account.deleteConfirm': 'למחוק את החשבון?',
  'account.deleteText': 'החבילות שלך יימחקו. חבילה ששיתפת עם הרשאת עריכה עוברת למי שקיבל ממך הרשאת עריכה ראשון. אי אפשר לבטל את זה.',
  'account.passesTo': 'עוברת ל־{name}',
  'account.deleted': 'תימחק',
  'account.deleteYes': 'למחוק',
  'account.deleteNo': 'ביטול',

  'share.title': 'שיתוף ״{name}״',
  'share.level': 'הרשאה',
  'share.view': 'צפייה',
  'share.edit': 'עריכה',
  'share.levelsHint': 'צפייה: אפשר לשחק עם החבילה. עריכה: אפשר גם להוסיף, לשנות ולמחוק קלפים.',
  'share.sharedWith': 'משותפת עם',
  'share.remove': 'הסרת השיתוף עם {name}',
  'share.userNotFound': 'אין משתמש בשם הזה',
  'share.ownDeck': 'זה שם המשתמש שלך',

  'game.codeLabel': 'קוד משחק {code}',
  'game.connected': 'מחובר',
  'game.connecting': 'מתחבר',
  'game.offline': 'מנותק',
  'game.leave': 'יציאה מהמשחק',
  'game.leaveConfirm': 'לצאת מהמשחק?',
  'game.questionCard': 'קלף שחור',
  'game.whoAnswered': 'מי ענה',
  'game.answers': 'תשובות',
  'game.winner': 'הזוכה',
  'game.nextPlayer': 'עבור לשחקן הבא',
  'game.confirmPick': 'בדוק?',
  'game.handWritten': 'נכתב ביד',
  'game.blank': 'ריק',
  'game.answersNeeded': '{count} תשובות',
  'game.points': 'נקודות:',
  'game.inHand': 'קלפים ביד:',
  'game.picked': 'בחרת:',
  'game.youWon': 'ניצחת!',
  'game.roundWinner': 'הזוכה בסיבוב:',
  'game.questionComing': 'הקלף השחור בדרך',
  'game.send': 'שלח תשובה',
  'game.sentCard': 'קלף שחור — התשובה שלך נשלחה',
  'game.blankUsed': 'הקלף הריק נוצל — יחזור בסיבוב הבא',
  'game.writeYourOwn': 'כתבו משהו משלכם',
  'game.blankCard': 'קלף ריק — כתבו משהו משלכם',
  'game.yourCard': 'הקלף שכתבת',
  'game.yourCardText': 'הקלף שכתבת: {text}',
  'game.yourCardInBlank': 'הקלף שכתבת: {text} — {blank}',
  'game.cardInBlank': '{text} — {blank}',
  'game.blank1': 'ריק ראשון',
  'game.blank2': 'ריק שני',
  'game.blank3': 'ריק שלישי',
  'game.saveWritten': 'שמור',

  'end.randomWon': 'רנדו ניצח',
  'end.fatality': 'פטאליטי.',
  'end.home': 'חזרה למסך הבית',
  'end.over': 'המשחק נגמר',
  'end.hostGone': 'המארח יצא ולא חזר בזמן, אז סגרנו את המשחק.',

  'intro.welcome': 'ברוכים הבאים',
  'intro.howTo': 'ככה משחקים, בחצי דקה',
  'intro.judgeTitle': 'בכל סיבוב יש שופט',
  'intro.judgeText': 'השופט שולף קלף שאלה עם מקום ריק.',
  'intro.question': 'הסוד שלי להצלחה בחיים:',
  'intro.chooseTitle': 'כולם בוחרים תשובה',
  'intro.chooseText': 'כל שאר השחקנים בוחרים מהיד את הקלף הכי מצחיק.',
  'intro.pickTitle': 'השופט בוחר זוכה',
  'intro.pickText': 'השופט קורא את כל התשובות. התשובה הכי טובה מקבלת נקודה.',
  'intro.point': 'נקודה ל{name}',
  'intro.nextTitle': 'התור עובר הלאה',
  'intro.nextText': 'בסיבוב הבא, השחקן הבא הוא השופט.',
  'intro.judge': 'שופט',
  'intro.randoTitle': 'הכירו את רנדו',
  'intro.randoText': 'בכל סיבוב רנדו שולח תשובה אקראית. אם השופט בוחר בו 3 פעמים, המשחק נגמר.',
  'intro.randoTally': 'רנדו ניצח 3 פעמים',
  'intro.randoWon': 'רנדו ניצח',
  'intro.ready': 'יאללה!',
  'intro.readyText': 'עכשיו אתם יודעים הכל.',
  'intro.play': 'בואו נשחק',
  'intro.skip': 'דלג',
  'intro.hand1': 'טחינה על הכל',
  'intro.hand2': 'ריב על המזגן',
  'intro.hand3': 'פלאפל בשלוש לפנות בוקר',
  'intro.hand4': 'חניה בתל אביב',
  'intro.player1': 'שירה',
  'intro.player2': 'יוני',
  'intro.player3': 'מאיה',
  'intro.player4': 'תום',
};

export default he;
